export const giaVon = {
  title: 'Giá vốn',
  titles: {
    list: 'Danh sách giá vốn lô hàng',
    edit: 'Cập nhật giá vốn lô hàng',
    config: 'Cập nhật phí cố định giá vốn',
  },
  fields: {
    maLoHang: 'Mã lô hàng',
    tenSanPham: 'Tên sản phẩm',
    tenKhachHang: 'Khách hàng',
    maContainer: 'Mã container',
    thanhTienVon2: 'Thành tiền vốn 2',
    thanhTienChot: 'Thành tiền chốt',
    laiChuaThue: 'Lãi chưa thuế',
    mucCanhBao: 'Mức cảnh báo',
    actions: 'Thao tác',
    phiGiaVonCoDinh: 'Phí cố định giá vốn',
  },
  filter: {
    all: 'Tất cả',
    searchPlaceholder: 'Tìm theo mã lô / tên sản phẩm',
    fromDate: 'Từ ngày',
    toDate: 'Đến ngày',
    warningLevel: 'Mức cảnh báo',
  },
  update: {
    chiPhiDauTQ: 'Chi phí đầu TQ',
    phiShip: 'Phí ship',
    phiKhac: 'Phí khác',
    thueNKThuKhach: 'Thuế NK thu khách',
    thueVATThuKhach: 'Thuế VAT thu khách',
    thueKhac: 'Thuế khác',
    phanTramUTNK: '% ủy thác NK',
    utnk: 'Ủy thác NK',
    chiPhiKTCL: 'Chi phí KTCL',
  },
  actions: {
    exportExcel: 'Xuất Excel',
    config: 'Phí cố định',
  },
  messages: {
    noData: 'Không có dữ liệu',
  },
}
